import { VIRTUAL_PAGES } from "./config";

function sendEvent(event, id) {
  if (!window.MetricsCounter) return;
  const virtualPage = `${VIRTUAL_PAGES[event].virtualPage}${id}`;
  const virtualTitle = `${VIRTUAL_PAGES[event].virtualTitle}${id}`;

  var mOpts = {
    title: virtualTitle,
    referer: window.location.href,
  };
  setTimeout(() => {
    ym(window.MetricsCounter, "hit", virtualPage, mOpts);
  }, 1000);
}

export { sendEvent };
